import React from "react";
import { Globe, Server, Lock, ArrowRight, Terminal } from "lucide-react";

const STEPS = [
  { icon: Globe, title: "1. Point Your GoDaddy Domain", body: "In GoDaddy DNS settings, update your domain's nameservers to Hostinger's nameservers (ns1.dns-parking.com, ns2.dns-parking.com), OR add an A record pointing to your Hostinger server IP." },
  { icon: Server, title: "2. Host on Hostinger VPS / Cloud", body: "This full-stack app (React + FastAPI + MongoDB) runs best on a Hostinger VPS or Cloud plan. Upload the built frontend and run the FastAPI backend with a process manager like PM2 or systemd." },
  { icon: Terminal, title: "3. Configure Nginx Reverse Proxy", body: "Serve the React build as static files and proxy /api requests to the FastAPI backend (port 8001). This keeps the frontend and backend under one domain." },
  { icon: Lock, title: "4. Enable Free SSL", body: "Use Hostinger's free Let's Encrypt SSL so your store loads securely on https://yourdomain.com. Auto-renewal keeps it active." },
];

const NGINX = `server {
  listen 80;
  server_name yourdomain.com;

  location /api/ {
    proxy_pass http://127.0.0.1:8001;
    proxy_set_header Host $host;
    proxy_set_header X-Real-IP $remote_addr;
  }

  location / {
    root /var/www/millionpixel/build;
    try_files $uri /index.html;
  }
}`;

export default function HostingerGuide() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-14">
      <p className="accent-label">Deployment Guide</p>
      <h1 className="font-serif text-3xl lg:text-5xl font-bold text-rose-950 mt-2">Host On Your Own Domain</h1>
      <p className="text-muted-foreground mt-4 leading-relaxed max-w-2xl">Follow these steps to serve Million Pixels on your custom domain (registered on GoDaddy) using Hostinger hosting — so customers see your brand at <b>yourdomain.com</b>.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-10">
        {STEPS.map((s, i) => (
          <div key={i} className="bg-white border border-rose-900/15 rounded-2xl p-6 hover-lift fade-up" style={{ animationDelay: `${i * 70}ms` }}>
            <s.icon className="w-8 h-8 text-amber-600 mb-4" />
            <h3 className="font-serif text-lg font-semibold text-rose-950 mb-2">{s.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <h2 className="font-serif text-xl font-semibold text-rose-950 mb-3">Sample Nginx Config</h2>
        <pre className="bg-rose-950 text-amber-50 rounded-xl p-5 text-xs overflow-x-auto font-mono leading-relaxed" data-testid="hostinger-nginx-config">{NGINX}</pre>
      </div>

      <div className="mt-8 bg-amber-50 border border-amber-200 rounded-xl p-5 text-sm text-amber-900">
        <b>Note:</b> This preview is hosted on Emergent. When you're ready to go live on your domain, use the Deploy option — our team can guide you through pointing your GoDaddy domain and Hostinger hosting to this exact application.
      </div>
    </div>
  );
}
